// Shared email-preview rendering for the two report review surfaces — the manual "Generate
// progress reports" modal and the hold-for-review batch modal. Both show the FULL email and keep
// it live while the admin edits only the summary. The server composes each body around a sentinel
// and hands over the two halves (html_before / html_after) plus a summary-less html_empty and the
// as-composed html; the client drops the edited summary between the halves, so there's no server
// round-trip per keystroke.

// Mirrors escapeHtml in the server's prep_report_template — the preview must escape exactly as the
// real render does, or what's on screen won't be what goes out.
export const escapeHtml = (s) => String(s ?? "")
    .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

// The full email body with `narrative` spliced into the summary slot. `scaffold` carries the
// server's split (html_before / html_after), a summary-less html_empty, and the as-composed html
// as a last resort if the split ever failed.
export const emailPreviewHtml = (scaffold, narrative) => {
    if (!scaffold) return "";
    const text = (narrative || "").trim();
    if (!text) return scaffold.html_empty || scaffold.html || "";
    if (scaffold.html_before == null || scaffold.html_after == null) return scaffold.html || "";
    const paras = text.split(/\n{2,}/)
        .map((p) => p.trim()).filter(Boolean)
        .map((p) => `<p style="margin:0 0 8px">${escapeHtml(p)}</p>`)
        .join("");
    return scaffold.html_before + paras + scaffold.html_after;
};

// The email body carries no body-level font — mail clients supply their own, and an iframe's
// default is Times New Roman, which is why an unstyled pane looked nothing like the delivered
// mail. These are Gmail's defaults (Arial, ~13px, #202124), so the pane reads like the real thing.
// The body's own inline styles still win, being more specific.
export const emailPreviewDoc = (html) => `<!doctype html><html><head><meta charset="utf-8"><style>
  body { margin: 0; padding: 16px; color: #202124;
         font: 13px/1.5 Arial, Helvetica, "Apple SD Gothic Neo", "Malgun Gothic", sans-serif; }
  ul { margin: 0 0 12px; padding-left: 22px; }
  a { color: #1a73e8; }
</style></head><body>${html}</body></html>`;
